module.exports = __webpack_public_path__ + "img/image_case_1.594f9b91.png";